import { CopyLine } from './copy-line';
import { addressWarning } from './format';
import { Glyph } from './glyphs';
import type { AgentAddress } from './types';
import connectionsCopy from '@/i18n/ns/connections';
import { useNamespaceCopy } from '@/i18n/ns';

/**
 * The one MCP address to paste into an external agent, with Copy, and under
 * it what the server itself reports about reaching it (only on this computer
 * or network, or not answering right now). Connections and the chat card show
 * the same field, so both say the same thing about the same address.
 */
export function AddressField({ address }: { address: AgentAddress }) {
  const copy = useNamespaceCopy(connectionsCopy);
  const warning = addressWarning(address, copy);
  return (
    <>
      <CopyLine value={address.url} label={copy.copyWhatAddress} />
      {warning && (
        <p className="ws-agent-address-warning">
          <Glyph name="alert" size={13} />
          <span>{warning}</span>
        </p>
      )}
    </>
  );
}
